import { UsersThree } from "@phosphor-icons/react";

import Skeleton from "common/components/ui/Skeleton";
import { Tag } from "common/components/ui/Tag";

import useLinkedInGroups from "../../../datahooks/useLinkedInGroups";

interface GroupTargetingLabelProps {
  groupId: string;
  isLoading: boolean;
}

export default function GroupTargetingLabel({
  groupId,
  isLoading,
}: GroupTargetingLabelProps) {
  const { linkedInGroup, isLoadingLinkedInGroup } = useLinkedInGroups({
    groupId,
  });

  if (isLoading || isLoadingLinkedInGroup)
    return <Skeleton className="h-7 w-60" />;

  return (
    <Tag
      size="md"
      variant="primary-black"
      leftIcon={<UsersThree weight="fill" />}
      className="max-w-full"
    >
      {linkedInGroup ? linkedInGroup.name : "LinkedIn Group"}
    </Tag>
  );
}
